import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3688cc23&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3688cc23&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3688cc23')) {
      api.createRecord('3688cc23', component.options)
    } else {
      api.reload('3688cc23', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3688cc23&", function () {
      api.rerender('3688cc23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Urbanwarehouse/modules/CustomerDetailsDialog/index.vue"
export default component.exports